<script>

export default {
  name: 'PhoneNumberInput',

  props: {
    value: {
      required: false,
      default: null,
    },
  },

  data() {
    return {
      number: '',
    };
  },

  created() {
    this.number = this.value
    this.acceptNumber()
  },

  methods: {
    acceptNumber() {
      let x = this.number.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.number = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }
  },
};

</script>

<template>
  <input v-bind="$attrs" v-model="number" type="text" @input="acceptNumber" name="phone"
         class="bg-secondary rounded border border-grey-lighter w-full py-2 px-3 leading-tight focus:outline-none">
</template>
